import { zodResolver } from '@hookform/resolvers/zod';
import { useForm } from 'react-hook-form';
import { z } from 'zod';

const CreateUserFormSchema = z.object({
  role: z.string().default('user'),
  email: z.string().min(1, 'Email is required').email(),
  firstName: z.string().min(1, 'First Name is required'),
  lastName: z.string().min(1, 'Last Name is required'),
  address: z.string(),
  city: z.string().optional(),
  state: z.string().optional(),
  country: z.string().optional(),
  postalCode: z.string().nullable().optional(),
  dateOfBirth: z.date().nullable().optional(),
  phone: z.string().min(1, 'Phone is required'),
});

export type CreateUserForm = z.infer<typeof CreateUserFormSchema>;

const createUserFormDefaultValues: CreateUserForm = {
  role: 'user',
  email: '',
  firstName: '',
  lastName: '',
  address: '',
  phone: '',
  city: '',
  state: '',
  country: '',
  postalCode: null,
  dateOfBirth: null
};

export const useCreateUserForm = () => {
  const form = useForm({
    defaultValues: createUserFormDefaultValues,
    resolver: zodResolver(CreateUserFormSchema),
    reValidateMode: 'onBlur',
  });

  return form;
};
